module.exports = __webpack_public_path__ + "static/BannerHunting-902ae0ba877dfcdebe88b571361e7570.png";